import { AssignmentResponse } from '@/types';

export const isContentGenerated = (
  assignment: AssignmentResponse,
  type: 'angle' | 'briefing' | 'script'
) => {
  switch (type) {
    case 'angle':
      return !!assignment.editorialAngle;
    case 'briefing':
      return !!assignment.avatarBriefing;
    case 'script':
      return !!assignment.interviewScript;
    default:
      return false;
  }
};
